
// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { createPortal } from 'react-dom';

// import '../styles/LeaveManagement.css';



// const WFHManagement = () => {
//     const navigate = useNavigate();
//     const [wfh, setWfh] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedLeave, setSelectedLeave] = useState(null);
//     const [summarySearch, setSummarySearch] = useState('');
//     const [showDetailModal, setShowDetailModal] = useState(false);

//     const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
//     const [remarkText, setRemarkText] = useState("");


//     const [summaryDepartment, setSummaryDepartment] = useState('All');
//     const entriesPerPage = 10;
//     // const teams = useMemo(() => ["FI Design", "FSPLO", "LTDM PC", "DDI", "DMS", "FI-IE", "LTO"], []);
//     const teams = useMemo(() => [
//         "FI Design",
//         "FSPLO",
//         "LTDM PC",
//         "DDI",
//         "DMS",
//         "FI-IE",
//         "LTO",
//         "GTE-Technology Operations" // New Team Added
//     ], []);

//     const now = new Date();
//     const currentMonth = (now.getMonth() + 1).toString();
//     const currentYear = now.getFullYear().toString();

//     const [filters, setFilters] = useState({
//         department: 'All',
//         month: currentMonth,
//         year: currentYear,
//     });



//     const pendingCount = useMemo(() => {
//         return wfh.filter(l => l.status === '0' || l.status === null).length;
//     }, [wfh]);

//     // Wrapped in useCallback to allow use in handleMedicalAction
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         try {
//             const storedUser = localStorage.getItem('user');
//             const authUser = JSON.parse(storedUser) || {};
//             const viewerId = authUser.EmpId || authUser.empid || "";
//             const role = authUser.Role || authUser.role || "";

//             const res = await fetch(`/gt-api/get_all_wfh.php`, {
//                 credentials: "include"
//             });
//             const data = await res.json();

//             if (data.success) {
//                 setWfh(data.requests);
//             } else {
//                 console.error("Backend Error:", data.message);
//             }
//         } catch (err) {
//             console.error("Fetch Error:", err);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     const handleDeleteLeave = async (id) => {
//         if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
//         setProcessing(true);
//         try {
//             const res = await fetch(`/gt-api/delete_wfh.php?id=${id}`, {
//                 method: 'GET',
//                 credentials: "include"
//             });
//             const result = await res.json();
//             if (result.success) {
//                 await fetchData();
//             } else {
//                 alert("Delete failed: " + result.message);
//             }
//         } catch (e) {
//             alert("Connection error during deletion");
//         } finally {
//             setProcessing(false);
//         }
//     };


//     const handleMedicalAction = async (leaveId, actionType) => {
//         // actionType: 1 for Sick, 2 for Earned
//         setProcessing(true);
//         try {

//             // Determine new leave type based on action
//             const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

//             const response = await fetch("/gt-api/verify_medical.php", {
//                 method: "POST",
//                 credentials: "include",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     leave_id: leaveId,
//                     status: actionType,
//                     leavetype: newLeaveType   // 👈 added this
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 setSelectedLeave(prev => ({
//                     ...prev,
//                     medical_doc_status: actionType,
//                     leavetype: newLeaveType   // 👈 update UI state also
//                 }));

//                 await fetchData(); // Refresh list
//             }

//         } catch (error) {
//             console.error("Verification failed", error);
//         } finally {
//             setProcessing(false);
//         }
//     };

//     const openRemarkModal = (id, statusValue) => {

//         const actionType =
//             statusValue === "Approved"
//                 ? "APPROVE"
//                 : "REJECT";

//         setRemarkModal({
//             show: true,
//             id: id,
//             status: statusValue,
//             actionType: actionType
//         });

//         setRemarkText("");
//     };

//     const handleFinalSubmit = async () => {

//         if (!remarkText.trim()) {
//             alert("Please enter a remark before proceeding.");
//             return;
//         }

//         setProcessing(true);

//         try {

//             const res = await fetch("/gt-api/update_wfh_status.php", {
//                 credentials: "include",
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     id: remarkModal.id,
//                     status: remarkModal.status,
//                     remark: remarkText
//                 })
//             });

//             const result = await res.json();

//             if (result.success) {

//                 await fetchData();

//                 setRemarkModal({
//                     show: false,
//                     id: null,
//                     status: null,
//                     actionType: ""
//                 });

//                 setShowDetailModal(false);

//             }

//         } catch (e) {
//             alert("Update failed");
//         } finally {
//             setProcessing(false);
//         }

//     };



//     // const wfhUsage = useMemo(() => {

//     //     const usage = {};

//     //     wfh.forEach(l => {

//     //         if (l.status !== "Approved") return;

//     //         const key = l.empid;

//     //         if (!usage[key]) {
//     //             usage[key] = {
//     //                 name: l.employee_name,
//     //                 dept: l.department,
//     //                 total: 0
//     //             };
//     //         }

//     //         usage[key].total += parseFloat(l.total_days || 0);

//     //     });

//     //     return Object.values(usage).filter(emp =>
//     //         !summarySearch ||
//     //         emp.name.toLowerCase().includes(summarySearch.toLowerCase())
//     //     );

//     // }, [wfh, summarySearch]);


//     const wfhUsage = useMemo(() => {

//         const usage = {};

//         wfh.forEach(l => {

//             if (l.status !== "Approved") return;

//             const key = l.empid;

//             if (!usage[key]) {
//                 usage[key] = {
//                     name: l.employee_name,
//                     dept: l.department,
//                     total: 0
//                 };
//             }

//             usage[key].total += parseFloat(l.total_days || 0);

//         });

//         return Object.values(usage).filter(emp => {

//             const matchesSearch =
//                 !summarySearch ||
//                 emp.name.toLowerCase().includes(summarySearch.toLowerCase());

//             const matchesDept =
//                 summaryDepartment === "All" ||
//                 emp.dept === summaryDepartment;

//             return matchesSearch && matchesDept;

//         });

//     }, [wfh, summarySearch, summaryDepartment]); // ✅ ADD summaryDepartment here

//     const chartData = useMemo(() => {

//         const teamsToDisplay = filters.department === 'All'
//             ? teams
//             : [filters.department];

//         return teamsToDisplay.map(team => {

//             const teamFiltered = wfh.filter(l => {

//                 const dateParts = l.start ? l.start.split('-') : [];
//                 const lYear = dateParts[0];
//                 const lMonth = l.start ? parseInt(dateParts[1]).toString() : "";

//                 const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                 const matchesYear = filters.year === 'All' || lYear === filters.year;

//                 return l.department === team && matchesMonth && matchesYear;

//             });

//             return {
//                 name: team,

//                 Approved: teamFiltered
//                     .filter(l => l.status === 'Approved')
//                     .reduce((sum, l) => sum + parseFloat(l.total_days || 0), 0),

//                 Pending: teamFiltered
//                     .filter(l => l.status === 'Pending')
//                     .reduce((sum, l) => sum + parseFloat(l.total_days || 0), 0)
//             };
//         });

//     }, [wfh, filters.month, filters.year, filters.department, teams]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//         setCurrentPage(1);
//     };

//     const handleTeamClick = (teamName) => {
//         setFilters(prev => ({ ...prev, department: teamName }));
//         setCurrentPage(1);
//     };

//     const getStatusLabel = (status) => {
//         if (status === 'Approved') return 'Approved';
//         if (status === 'Rejected') return 'Rejected';
//         return 'Pending';
//     };
//     const filteredTableData = wfh.filter(l => {

//         const dateParts = l.start ? l.start.split('-') : [];
//         const lYear = dateParts[0] || "";
//         const lMonth = l.start ? parseInt(dateParts[1]).toString() : "";

//         const matchesDept =
//             filters.department === 'All' || l.department === filters.department;

//         const matchesMonth =
//             filters.month === 'All' || lMonth === filters.month;

//         const matchesYear =
//             filters.year === 'All' || lYear === filters.year;

//         const matchesSearch =
//             l.employee_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             l.empid?.toString().includes(searchTerm);

//         return matchesDept && matchesMonth && matchesYear && matchesSearch;

//     });

//     const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
//     const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

//     if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

//     return (
//         <div className="leave-mgmt-container animate-fade">


//             {processing && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
//                     <div className="processing-loader">
//                         <div className="spinner-ring"></div>
//                         <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
//                     </div>
//                 </div>,
//                 document.body
//             )}






//             {showDetailModal && selectedLeave && createPortal(
//                 <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
//                     <div className="detail-modal glass-morph animate-slide-up"
//                         onClick={e => e.stopPropagation()}
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             maxHeight: '90vh',
//                             width: '80%',
//                             maxWidth: '600px'
//                         }}>


//                         <div className="modal-header" style={{ flexShrink: 0 }}>
//                             <h3 className="cyan-text">APPLICATION_DETAILS</h3>
//                             <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
//                         </div>

//                         <div
//                             className="modal-body detail-grid"
//                             style={{
//                                 padding: '20px',
//                                 overflowY: 'auto',
//                                 flex: 1
//                             }}
//                         >

//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>EMPLOYEE :</strong> {selectedLeave.employee_name}
//                             </p>

//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>PERIOD :</strong> {selectedLeave.start} → {selectedLeave.end}
//                             </p>

//                             <p style={{ marginBottom: '15px' }}>
//                                 <strong>UNIT :</strong> {parseFloat(selectedLeave.total_days)}
//                             </p>

//                             <div
//                                 style={{
//                                     marginTop: '15px',
//                                     padding: '12px',
//                                     background: 'rgba(255,255,255,0.03)',
//                                     borderRadius: '6px'
//                                 }}
//                             >

//                                 <strong>REASON :</strong>

//                                 <div
//                                     style={{
//                                         marginTop: '6px',
//                                         color: '#ccc',
//                                         lineHeight: '1.6'
//                                     }}
//                                 >
//                                     {selectedLeave.reason}
//                                 </div>

//                             </div>

//                         </div>

//                         <div className="modal-footer" style={{ flexShrink: 0 }}>
//                             {selectedLeave.status === 'Pending' && (
//                                 <div className="modal-footer-actions">
//                                     <button
//                                         className="btn-approve"
//                                         onClick={() => openRemarkModal(selectedLeave.id, "Approved")}
//                                     >
//                                         APPROVE
//                                     </button>
//                                     <button
//                                         className="btn-reject"
//                                         onClick={() => openRemarkModal(selectedLeave.id, "Rejected")}
//                                     >
//                                         REJECT
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             {remarkModal.show && createPortal(
//                 <div className="modal-overlay" style={{ zIndex: 2000 }}>
//                     <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

//                         <div className="modal-header">
//                             <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
//                                 {remarkModal.actionType}_CONFIRMATION
//                             </h3>
//                         </div>
//                         <div className="modal-body">
//                             <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
//                             <textarea
//                                 className="filter-select"
//                                 style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
//                                 placeholder="Write remark here..."
//                                 value={remarkText}
//                                 onChange={(e) => setRemarkText(e.target.value)}
//                             />
//                         </div>
//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>

//                             <button
//                                 className="page-btn"
//                                 style={{ flex: 1 }}
//                                 onClick={() => setRemarkModal({ show: false })}
//                             >
//                                 CANCEL
//                             </button>

//                             <button
//                                 className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"}
//                                 style={{ flex: 1, padding: '10px' }}
//                                 onClick={handleFinalSubmit}
//                                 disabled={processing}
//                             >
//                                 {processing ? "PROCESSING..." : `CONFIRM ${remarkModal.actionType}`}
//                             </button>

//                         </div>
//                     </div>
//                 </div>,
//                 document.body
//             )}

//             <div className="leave-dashboard-top">
//                 <div className="team-cards-grid">
//                     {teams.map((team, idx) => {
//                         const filteredForCard = wfh.filter(l => {
//                             const dateParts = l.fromdate ? l.fromdate.split('-') : [];
//                             const lYear = dateParts[0];
//                             const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
//                             const matchesMonth = filters.month === 'All' || lMonth === filters.month;
//                             const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
//                             return l.Department === team && matchesMonth && matchesYear;
//                         });

//                         return (
//                             <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
//                                 <h4>{team}</h4>
//                                 <div className="card-stats">
//                                     <span className="stat-item approved">{filteredForCard.filter(l => l.status === '1').length}A</span>
//                                     <span className="stat-item pending">{filteredForCard.filter(l => (l.status === '0' || l.status === null)).length}P</span>
//                                 </div>
//                             </div>

//                         );
//                     })}


//                     <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
//                         onClick={() => {
//                             setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
//                             setCurrentPage(1);
//                         }}>
//                         <h4 className="cyan-text">GLOBAL_VIEW</h4>
//                         <div className="card-stats"><span>{wfh.length} TOTAL ALL TIME</span></div>
//                     </div>

//                     {/* <div
//                         className="team-mini-card glass-morph medical-card"
//                         onClick={() => navigate('/medical-reports')} // Replace with your actual route path
//                         style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
//                     >
//                         <h4 className="cyan-text">MEDICAL_REPORTS</h4>
//                         <div className="card-stats">
//                             <span style={{ fontSize: '10px', color: '#888' }}>VIEW_DOCUMENTS_HUB</span>
//                         </div>
//                     </div> */}
//                 </div>

//                 <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
//                         {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
//                     </h5>
//                     <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
//                         <ResponsiveContainer width="100%" height={220}>
//                             <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
//                                 <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
//                                 <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
//                                 <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
//                                 <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
//                                 <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>


//             </div>

//             <div className="filter-toolbar glass-morph">

//                 <div className="leavefilter">
//                     <label>MONTH</label>
//                     <select name="month" value={filters.month} onChange={handleFilterChange}>
//                         <option value="All">ALL MONTHS</option>
//                         {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
//                             <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="leavefilter">
//                     <label>YEAR</label>
//                     <select name="year" value={filters.year} onChange={handleFilterChange}>
//                         <option value="All">ALL YEARS</option>
//                         <option value="2024">2024</option>
//                         <option value="2025">2025</option>
//                         <option value="2026">2026</option>
//                     </select>
//                 </div>

//                 <div className="leavefilter">
//                     <label>DEPARTMENT</label>
//                     <select name="department" value={filters.department} onChange={handleFilterChange}>
//                         <option value="All">ALL DEPARTMENTS</option>
//                         {teams.map(team => (
//                             <option key={team} value={team}>{team.toUpperCase()}</option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="leavefilter search-group">
//                     <label>EMPLOYEE_SEARCH</label>
//                     <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </div>

//                 <div className="leavefilter reset-group">
//                     <label>SYSTEM_CONTROL</label>
//                     <button
//                         className="reset-action-btn"
//                         onClick={() => {
//                             setFilters({
//                                 department: 'All',
//                                 month: currentMonth, // Returns to original current month
//                                 year: currentYear,   // Returns to original current year
//                             });
//                             setSearchTerm('');
//                             setCurrentPage(1);
//                         }}
//                     >
//                         <span className="reset-icon"></span>
//                         RESET_FILTER
//                     </button>
//                 </div>
//             </div>

//             <div className="module-glass-card table-wrapper">
//                 <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
//                     <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
//                     {pendingCount > 0 && (
//                         <div className="notif-badge-main">{pendingCount}</div>
//                     )}
//                 </div>


//                 <table className="cyber-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
//                     <thead>
//                         <tr>


//                             <th style={{ width: '220px', textAlign: 'left', padding: '12px' }}>EMPLOYEE</th>

//                             <th style={{ width: '160px', textAlign: 'left', padding: '12px' }}>DEPT</th>

//                             <th style={{ width: '140px', textAlign: 'center', padding: '12px' }}>FROM</th>

//                             <th style={{ width: '140px', textAlign: 'center', padding: '12px' }}>TO</th>

//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>UNIT</th>

//                             <th style={{ width: '140px', textAlign: 'center', padding: '12px' }}>STATUS</th>

//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>REVIEW</th>

//                             <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>ACTION</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {currentEntries.map((l, i) => (

//                             <tr key={i} className="row-hover">

//                                 <td className="emp-name-cell"
//                                     style={{
//                                         padding: '14px 12px',
//                                         whiteSpace: 'nowrap',
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis'
//                                     }}>
//                                     {l.employee_name}
//                                 </td>

//                                 <td style={{ padding: '14px 12px' }}>
//                                     {l.department}
//                                 </td>

//                                 <td style={{ textAlign: 'center' }}>
//                                     {l.start}
//                                 </td>

//                                 <td style={{ textAlign: 'center' }}>
//                                     {l.end}
//                                 </td>

//                                 <td style={{ fontWeight: 'bold', color: '#00fff2', textAlign: 'center' }}>
//                                     {parseFloat(l.total_days)}
//                                 </td>

//                               <td style={{ textAlign: 'center', transform: 'translateX(45px)' }}>
//                                     <span className={`status-pill ${getStatusLabel(l.status).toLowerCase()}`} style={{ fontSize: '11px' }}>
//                                         {getStatusLabel(l.status)}
//                                     </span>
//                                 </td>

//                                  <td style={{ textAlign: 'center', transform: 'translateX(35px)' }}>
//                                     <button
//                                         className="info-btn-circle"
//                                          style={{ marginTop: '-4px' }}
//                                         onClick={() => { setSelectedLeave(l); setShowDetailModal(true); }}
//                                     >
//                                         <span className="info-icon">i</span>
//                                     </button>
//                                 </td>

//                                 <td style={{ textAlign: 'center' }}>
//                                     {(l.status !== '0' && l.status !== null) && (
//                                         <button
//                                             className="btn-delete-simple"
//                                             onClick={() => handleDeleteLeave(l.id)}
//                                             style={{
//                                                 background: 'none',
//                                                 border: '6px',
//                                                 padding: '0',
//                                                 cursor: 'pointer',
//                                                 fontSize: '22px',
//                                                 opacity: '0.8',
//                                                 display: 'inline-flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 marginTop: '-4px'
//                                             }}
//                                         >
//                                             🗑️
//                                         </button>
//                                     )}
//                                 </td>

//                             </tr>

//                         ))}
//                     </tbody>
//                 </table>





//                 <div className="pagination-footer">
//                     <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
//                     <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
//                     <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
//                 </div>
//             </div>




//             <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
//                     {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: '20px 20px 10px 20px',
//                         gap: '15px'
//                     }}>
//                         <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
//                             EMPLOYEE_WFH_USAGE
//                         </h3>

//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

//                             {/* ✅ New Department Filter for Summary Only */}
//                             <select
//                                 className="filter-select"
//                                 value={summaryDepartment}
//                                 onChange={(e) => setSummaryDepartment(e.target.value)}
//                                 style={{ fontSize: '12px' }}
//                             >
//                                 <option value="All">ALL DEPARTMENTS</option>
//                                 {teams.map(team => (
//                                     <option key={team} value={team}>{team.toUpperCase()}</option>
//                                 ))}
//                             </select>

                            
//                         </div>
//                     </div>
//                     <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
//                 </div>
//                 <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
//                     <div className="header-label" style={{ flex: '3' }}>EMPLOYEE</div>
//                     <div className="header-label" style={{ flex: '2' }}>DEPARTMENT</div>
//                     <div className="header-label" style={{ flex: '1.5', textAlign: 'center' }}>
//                         TOTAL_WFH_USED
//                     </div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>

//                     {wfhUsage.map((emp, idx) => (

//                         <div key={idx} className="row-hover"
//                             style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>

//                             <div style={{
//                                 flex: '3',
//                                 whiteSpace: 'nowrap',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis'
//                             }}>
//                                 {emp.name}
//                             </div>

//                             <div style={{
//                                 flex: '2',
//                                 whiteSpace: 'nowrap',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis'
//                             }}>
//                                 {emp.dept}
//                             </div>

//                             <div style={{
//                                 flex: '1.5',
//                                 textAlign: 'center',
//                                 fontWeight: '800',
//                                 fontSize: '15px',
//                                 color: '#00fff2'
//                             }}>
//                                 {emp.total}
//                             </div>

//                         </div>

//                     ))}

//                     {wfhUsage.length === 0 &&
//                         <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>
//                             DATA_NOT_FOUND_FOR_PERIOD
//                         </div>}

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default WFHManagement;






























import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { createPortal } from 'react-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import '../styles/LeaveManagement.css';

const POLICY_EFFECTIVE_DATE = '2026-09-22';

const getCurrentFinancialYear = (refDate = new Date()) => {
    const year = refDate.getFullYear();
    const month = refDate.getMonth(); // 0 = Jan, 3 = Apr
    const fyStartYear = month >= 3 ? year : year - 1;
    const fyEndYear = fyStartYear + 1;

    return {
        fyStartYear,
        fyEndYear,
        startDateStr: `${fyStartYear}-04-01`,
        endDateStr: `${fyEndYear}-03-31`,
        label: `FY ${fyStartYear}-${fyEndYear.toString().slice(-2)}`
    };
};

const WFHManagement = () => {
    const navigate = useNavigate();
    const [wfh, setWfh] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLeave, setSelectedLeave] = useState(null);
    const [summarySearch, setSummarySearch] = useState('');
    const [showDetailModal, setShowDetailModal] = useState(false);

    const [showReportModal, setShowReportModal] = useState(false);
    const [reportDates, setReportDates] = useState({ start: '', end: '' });
    const [reportData, setReportData] = useState([]);
    const [hasReportGenerated, setHasReportGenerated] = useState(false);

    const reportStartDateRef = useRef(null);
    const reportEndDateRef = useRef(null);

    const handleGenerateReport = (e) => {
        if (e) e.preventDefault();
        if (!reportDates.start || !reportDates.end) {
            alert("Please select both start and end dates.");
            return;
        }

        const filtered = wfh.filter(l => {
            if (!l.start) return false;
            return l.start >= reportDates.start && l.start <= reportDates.end;
        });

        setReportData(filtered);
        setHasReportGenerated(true);
    };

    const handleExportCSV = () => {
        if (reportData.length === 0) return;

        const headers = ["Employee ID", "Employee Name", "Department", "Start Date", "End Date", "Days", "Status", "Reason"];
        const rows = reportData.map(r => [
            `"${r.empid || ''}"`,
            `"${r.employee_name || ''}"`,
            `"${r.department || ''}"`,
            `"${r.start || ''}"`,
            `"${r.end || ''}"`,
            `"${r.total_days || 0}"`,
            `"${r.status || 'Pending'}"`,
            `"${(r.reason || '').replace(/"/g, '""')}"`
        ]);

        const csvContent = "data:text/csv;charset=utf-8," + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `WFH_Report_${reportDates.start}_to_${reportDates.end}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportPDF = () => {
        if (reportData.length === 0) return;

        try {
            const doc = new jsPDF("p", "pt", "a4");

            // Top Header Banner
            doc.setFillColor(15, 23, 42); // Navy slate (#0f172a)
            doc.rect(0, 0, 595, 75, "F");

            // Company & Report Title
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            doc.text("GTE ERP - WORK FROM HOME REPORT", 40, 34);

            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(56, 189, 248); // Cyan accent (#38bdf8)
            doc.text(`Duration: ${reportDates.start} to ${reportDates.end}`, 40, 56);

            // Summary Stats Card
            const totalDays = reportData.reduce((sum, r) => sum + parseFloat(r.total_days || 0), 0);

            doc.setFillColor(248, 250, 252); // Soft gray card
            doc.roundedRect(40, 90, 515, 45, 6, 6, "F");
            doc.setDrawColor(226, 232, 240);
            doc.roundedRect(40, 90, 515, 45, 6, 6, "D");

            doc.setFontSize(10);
            doc.setTextColor(15, 23, 42);
            doc.setFont("helvetica", "bold");
            doc.text(`Total Applications: ${reportData.length}`, 60, 117);
            doc.text(`Total Days Requested: ${totalDays}`, 220, 117);
            doc.text(`Generated Date: ${new Date().toLocaleDateString('en-GB')}`, 410, 117);

            // Table Columns & Data
            const tableColumns = ["EMP ID", "Employee Name", "Department", "From", "To", "Days", "Status", "Reason"];
            const tableRows = reportData.map(r => [
                r.empid || "-",
                r.employee_name || "-",
                r.department || "-",
                r.start || "-",
                r.end || "-",
                r.total_days || "0",
                getStatusLabel(r.status),
                r.reason || "-"
            ]);

            autoTable(doc, {
                startY: 150,
                head: [tableColumns],
                body: tableRows,
                theme: "grid",
                headStyles: {
                    fillColor: [37, 99, 235], // Professional Blue (#2563eb)
                    textColor: [255, 255, 255],
                    fontSize: 9,
                    fontStyle: "bold",
                    halign: "left"
                },
                bodyStyles: {
                    fontSize: 8.5,
                    textColor: [30, 41, 59]
                },
                alternateRowStyles: {
                    fillColor: [248, 250, 252]
                },
                columnStyles: {
                    0: { cellWidth: 50 },  // EMP ID
                    1: { cellWidth: 85 },  // Name
                    2: { cellWidth: 70 },  // Dept
                    3: { cellWidth: 60, halign: "center" }, // From
                    4: { cellWidth: 60, halign: "center" }, // To
                    5: { cellWidth: 40, halign: "center", fontStyle: "bold" }, // Days
                    6: { cellWidth: 55, halign: "center" }, // Status
                    7: { cellWidth: 95 }   // Reason
                },
                margin: { left: 40, right: 40 }
            });

            doc.save(`WFH_Report_${reportDates.start}_to_${reportDates.end}.pdf`);
        } catch (err) {
            console.error("PDF generation error:", err);
            alert("Unable to generate PDF report.");
        }
    };

    const [remarkModal, setRemarkModal] = useState({ show: false, id: null, status: null, actionType: "" });
    const [remarkText, setRemarkText] = useState("");


    const [summaryDepartment, setSummaryDepartment] = useState('All');
    const entriesPerPage = 10;
    // const teams = useMemo(() => ["FI Design", "FSPLO", "LTDM PC", "DDI", "DMS", "FI-IE", "LTO"], []);
    const teams = useMemo(() => [
        "FI Design",
        "FSPLO",
        "LTDM PC",
        "DDI",
        "DMS",
        "FI-IE",
        "LTO",
        "GTE-Technology Operations" // New Team Added
    ], []);

    const now = new Date();
    const currentMonth = (now.getMonth() + 1).toString();
    const currentYear = now.getFullYear().toString();

    const [filters, setFilters] = useState({
        department: 'All',
        month: currentMonth,
        year: currentYear,
    });



    const pendingCount = useMemo(() => {
        return wfh.filter(l => l.status === '0' || l.status === null).length;
    }, [wfh]);

    // Wrapped in useCallback to allow use in handleMedicalAction
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const storedUser = localStorage.getItem('user');
            const authUser = JSON.parse(storedUser) || {};
            const viewerId = authUser.EmpId || authUser.empid || "";
            const role = authUser.Role || authUser.role || "";

            const [wfhRes, empRes] = await Promise.all([
                fetch(`/gt-api/get_all_wfh.php`, { credentials: "include" }),
                fetch(`/gt-api/get_employees.php`, { credentials: "include" })
            ]);

            const data = await wfhRes.json();
            if (data.success) {
                setWfh(data.requests);
            } else {
                console.error("Backend Error:", data.message);
            }

            try {
                const empData = await empRes.json();
                if (empData.success && Array.isArray(empData.employees)) {
                    setAllEmployees(empData.employees);
                } else if (Array.isArray(empData)) {
                    setAllEmployees(empData);
                }
            } catch (empErr) {
                console.error("Employee Fetch Error:", empErr);
            }
        } catch (err) {
            console.error("Fetch Error:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDeleteLeave = async (id) => {
        if (!window.confirm("ARE_YOU_SURE? This will permanently delete the leave record even if approved.")) return;
        setProcessing(true);
        try {
            const res = await fetch(`/gt-api/delete_wfh.php?id=${id}`, {
                method: 'GET',
                credentials: "include"
            });
            const result = await res.json();
            if (result.success) {
                await fetchData();
            } else {
                alert("Delete failed: " + result.message);
            }
        } catch (e) {
            alert("Connection error during deletion");
        } finally {
            setProcessing(false);
        }
    };


    const handleMedicalAction = async (leaveId, actionType) => {
        // actionType: 1 for Sick, 2 for Earned
        setProcessing(true);
        try {

            // Determine new leave type based on action
            const newLeaveType = actionType === 1 ? "Sick Leave" : "Earned Leave";

            const response = await fetch("/gt-api/verify_medical.php", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    leave_id: leaveId,
                    status: actionType,
                    leavetype: newLeaveType   // 👈 added this
                }),
            });

            const result = await response.json();

            if (result.success) {
                setSelectedLeave(prev => ({
                    ...prev,
                    medical_doc_status: actionType,
                    leavetype: newLeaveType   // 👈 update UI state also
                }));

                await fetchData(); // Refresh list
            }

        } catch (error) {
            console.error("Verification failed", error);
        } finally {
            setProcessing(false);
        }
    };

    const openRemarkModal = (id, statusValue) => {

        const actionType =
            statusValue === "Approved"
                ? "APPROVE"
                : "REJECT";

        setRemarkModal({
            show: true,
            id: id,
            status: statusValue,
            actionType: actionType
        });

        setRemarkText("");
    };

    const handleFinalSubmit = async () => {

        if (!remarkText.trim()) {
            alert("Please enter a remark before proceeding.");
            return;
        }

        setProcessing(true);

        try {

            const res = await fetch("/gt-api/update_wfh_status.php", {
                credentials: "include",
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: remarkModal.id,
                    status: remarkModal.status,
                    remark: remarkText
                })
            });

            const result = await res.json();

            if (result.success) {

                await fetchData();

                setRemarkModal({
                    show: false,
                    id: null,
                    status: null,
                    actionType: ""
                });

                setShowDetailModal(false);

            }

        } catch (e) {
            alert("Update failed");
        } finally {
            setProcessing(false);
        }

    };



    // const wfhUsage = useMemo(() => {

    //     const usage = {};

    //     wfh.forEach(l => {

    //         if (l.status !== "Approved") return;

    //         const key = l.empid;

    //         if (!usage[key]) {
    //             usage[key] = {
    //                 name: l.employee_name,
    //                 dept: l.department,
    //                 total: 0
    //             };
    //         }

    //         usage[key].total += parseFloat(l.total_days || 0);

    //     });

    //     return Object.values(usage).filter(emp =>
    //         !summarySearch ||
    //         emp.name.toLowerCase().includes(summarySearch.toLowerCase())
    //     );

    // }, [wfh, summarySearch]);


    const wfhUsage = useMemo(() => {

        const usage = {};
        const currentFY = getCurrentFinancialYear();

        // 1. Initialize usage map with ALL employees from tblemployees
        allEmployees.forEach(emp => {
            const empIdStr = String(emp.EmpId || emp.empid || emp.id || "").trim();
            if (!empIdStr) return;

            const firstName = emp.FirstName || emp.firstname || "";
            const lastName = emp.LastName || emp.lastname || "";
            const fullName = `${firstName} ${lastName}`.trim() || emp.employee_name || emp.name || empIdStr;
            const dept = emp.DepartmentName || emp.Department || emp.department || emp.dept || emp.team || "Other";

            usage[empIdStr] = {
                empId: empIdStr,
                name: fullName,
                dept: dept,
                total: 0
            };
        });

        // Helper to match request empid or name to an employee in usage map
        const findUsageKey = (l) => {
            const reqEmpId = String(l.empid || "").trim();
            if (reqEmpId && usage[reqEmpId]) return reqEmpId;

            if (l.employee_name) {
                const reqNameLower = l.employee_name.trim().toLowerCase();
                const matchedKey = Object.keys(usage).find(k => usage[k].name.trim().toLowerCase() === reqNameLower);
                if (matchedKey) return matchedKey;
            }

            return reqEmpId || l.employee_name;
        };

        // 2. Accumulate approved WFH days in current FY
        wfh.forEach(l => {

            const key = findUsageKey(l);
            if (!key) return;

            if (!usage[key]) {
                usage[key] = {
                    empId: key,
                    name: l.employee_name || key,
                    dept: l.department || "Other",
                    total: 0
                };
            }

            // Count only if Approved, start date >= POLICY_EFFECTIVE_DATE, and within current FY
            if (l.status === "Approved" && l.start) {
                const reqStart = l.start;
                if (
                    reqStart >= POLICY_EFFECTIVE_DATE &&
                    reqStart >= currentFY.startDateStr &&
                    reqStart <= currentFY.endDateStr
                ) {
                    usage[key].total += parseFloat(l.total_days || 0);
                }
            }

        });

        // 3. Filter by search term and department
        return Object.values(usage).filter(emp => {

            const matchesSearch =
                !summarySearch ||
                emp.name.toLowerCase().includes(summarySearch.toLowerCase()) ||
                emp.empId.toLowerCase().includes(summarySearch.toLowerCase());

            const matchesDept =
                summaryDepartment === "All" ||
                emp.dept.toLowerCase() === summaryDepartment.toLowerCase();

            return matchesSearch && matchesDept;

        });

    }, [wfh, allEmployees, summarySearch, summaryDepartment]);

    const chartData = useMemo(() => {

        const teamsToDisplay = filters.department === 'All'
            ? teams
            : [filters.department];

        return teamsToDisplay.map(team => {

            const teamFiltered = wfh.filter(l => {

                const dateParts = l.start ? l.start.split('-') : [];
                const lYear = dateParts[0];
                const lMonth = l.start ? parseInt(dateParts[1]).toString() : "";

                const matchesMonth = filters.month === 'All' || lMonth === filters.month;
                const matchesYear = filters.year === 'All' || lYear === filters.year;

                return l.department === team && matchesMonth && matchesYear;

            });

            return {
                name: team,

                Approved: teamFiltered
                    .filter(l => l.status === 'Approved')
                    .reduce((sum, l) => sum + parseFloat(l.total_days || 0), 0),

                Pending: teamFiltered
                    .filter(l => l.status === 'Pending')
                    .reduce((sum, l) => sum + parseFloat(l.total_days || 0), 0)
            };
        });

    }, [wfh, filters.month, filters.year, filters.department, teams]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
        setCurrentPage(1);
    };

    const handleTeamClick = (teamName) => {
        setFilters(prev => ({ ...prev, department: teamName }));
        setCurrentPage(1);
    };

    const getStatusLabel = (status) => {
        if (status === 'Approved') return 'Approved';
        if (status === 'Rejected') return 'Rejected';
        return 'Pending';
    };
    const filteredTableData = wfh.filter(l => {

        const dateParts = l.start ? l.start.split('-') : [];
        const lYear = dateParts[0] || "";
        const lMonth = l.start ? parseInt(dateParts[1]).toString() : "";

        const matchesDept =
            filters.department === 'All' || l.department === filters.department;

        const matchesMonth =
            filters.month === 'All' || lMonth === filters.month;

        const matchesYear =
            filters.year === 'All' || lYear === filters.year;

        const matchesSearch =
            l.employee_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            l.empid?.toString().includes(searchTerm);

        return matchesDept && matchesMonth && matchesYear && matchesSearch;

    });

    const totalPages = Math.ceil(filteredTableData.length / entriesPerPage);
    const currentEntries = filteredTableData.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

    if (loading) return <div className="loading-container">GENESIS_SYSTEM_BOOTING...</div>;

    return (
        <div className="leave-mgmt-container animate-fade">


            {processing && createPortal(
                <div className="modal-overlay" style={{ zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}>
                    <div className="processing-loader">
                        <div className="spinner-ring"></div>
                        <p className="cyan-text" style={{ marginTop: '20px', letterSpacing: '3px' }}>Data_processing...</p>
                    </div>
                </div>,
                document.body
            )}






            {showDetailModal && selectedLeave && createPortal(
                <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
                    <div className="detail-modal glass-morph animate-slide-up"
                        onClick={e => e.stopPropagation()}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '90vh',
                            width: '80%',
                            maxWidth: '600px'
                        }}>


                        <div className="modal-header" style={{ flexShrink: 0 }}>
                            <h3 className="cyan-text">APPLICATION_DETAILS</h3>
                            <button className="close-btn" onClick={() => setShowDetailModal(false)}>×</button>
                        </div>

                        <div
                            className="modal-body detail-grid"
                            style={{
                                padding: '20px',
                                overflowY: 'auto',
                                flex: 1
                            }}
                        >

                            <p style={{ marginBottom: '15px' }}>
                                <strong>EMPLOYEE :</strong> {selectedLeave.employee_name}
                            </p>

                            <p style={{ marginBottom: '15px' }}>
                                <strong>PERIOD :</strong> {selectedLeave.start} → {selectedLeave.end}
                            </p>

                            <p style={{ marginBottom: '15px' }}>
                                <strong>UNIT :</strong> {parseFloat(selectedLeave.total_days)}
                            </p>

                            <div
                                style={{
                                    marginTop: '15px',
                                    padding: '12px',
                                    background: 'rgba(255,255,255,0.03)',
                                    borderRadius: '6px'
                                }}
                            >

                                <strong>REASON :</strong>

                                <div
                                    style={{
                                        marginTop: '6px',
                                        color: '#ccc',
                                        lineHeight: '1.6'
                                    }}
                                >
                                    {selectedLeave.reason}
                                </div>

                            </div>

                        </div>

                        <div className="modal-footer" style={{ flexShrink: 0 }}>
                            {selectedLeave.status === 'Pending' && (
                                <div className="modal-footer-actions">
                                    <button
                                        className="btn-approve"
                                        onClick={() => openRemarkModal(selectedLeave.id, "Approved")}
                                    >
                                        APPROVE
                                    </button>
                                    <button
                                        className="btn-reject"
                                        onClick={() => openRemarkModal(selectedLeave.id, "Rejected")}
                                    >
                                        REJECT
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>,
                document.body
            )}

            {remarkModal.show && createPortal(
                <div className="modal-overlay" style={{ zIndex: 2000 }}>
                    <div className="detail-modal glass-morph animate-slide-up" style={{ maxWidth: '450px' }}>

                        <div className="modal-header">
                            <h3 className={remarkModal.actionType === "APPROVE" ? "green-text" : "red-text"}>
                                {remarkModal.actionType}_CONFIRMATION
                            </h3>
                        </div>
                        <div className="modal-body">
                            <p style={{ marginBottom: '15px', color: '#ccc' }}>Provide a remark for this action:</p>
                            <textarea
                                className="filter-select"
                                style={{ width: '100%', height: '100px', padding: '12px', background: 'rgba(0,0,0,0.5)', color: '#fff', border: '1px solid #333', borderRadius: '8px' }}
                                placeholder="Write remark here..."
                                value={remarkText}
                                onChange={(e) => setRemarkText(e.target.value)}
                            />
                        </div>
                        <div className="modal-footer" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>

                            <button
                                className="page-btn"
                                style={{ flex: 1 }}
                                onClick={() => setRemarkModal({ show: false })}
                            >
                                CANCEL
                            </button>

                            <button
                                className={remarkModal.actionType === "APPROVE" ? "btn-approve" : "btn-reject"}
                                style={{ flex: 1, padding: '10px' }}
                                onClick={handleFinalSubmit}
                                disabled={processing}
                            >
                                {processing ? "PROCESSING..." : `CONFIRM ${remarkModal.actionType}`}
                            </button>

                        </div>
                    </div>
                </div>,
                document.body
            )}

            <div className="leave-dashboard-top">
                <div className="team-cards-grid">
                    {teams.map((team, idx) => {
                        const filteredForCard = wfh.filter(l => {
                            const dateParts = l.fromdate ? l.fromdate.split('-') : [];
                            const lYear = dateParts[0];
                            const lMonth = l.fromdate ? parseInt(dateParts[1]).toString() : "";
                            const matchesMonth = filters.month === 'All' || lMonth === filters.month;
                            const matchesYear = filters.year === 'All' || lYear === filters.year.toString();
                            return l.Department === team && matchesMonth && matchesYear;
                        });

                        return (
                            <div key={idx} className={`team-mini-card glass-morph ${filters.department === team ? 'active-card' : ''}`} onClick={() => handleTeamClick(team)}>
                                <h4>{team}</h4>
                                <div className="card-stats">
                                    <span className="stat-item approved">{filteredForCard.filter(l => l.status === '1').length}A</span>
                                    <span className="stat-item pending">{filteredForCard.filter(l => (l.status === '0' || l.status === null)).length}P</span>
                                </div>
                            </div>

                        );
                    })}


                    <div className={`team-mini-card glass-morph reset-card ${filters.department === 'All' ? 'active-card' : ''}`}
                        onClick={() => {
                            setFilters(prev => ({ ...prev, department: 'All', month: 'All', year: 'All' }));
                            setCurrentPage(1);
                        }}>
                        <h4 className="cyan-text">GLOBAL_VIEW</h4>
                        <div className="card-stats"><span>{wfh.length} TOTAL ALL TIME</span></div>
                    </div>

                    {/* <div
                        className="team-mini-card glass-morph medical-card"
                        onClick={() => navigate('/medical-reports')} // Replace with your actual route path
                        style={{ cursor: 'pointer', border: '1px border-left: 4px solid #00ff9d' }}
                    >
                        <h4 className="cyan-text">MEDICAL_REPORTS</h4>
                        <div className="card-stats">
                            <span style={{ fontSize: '10px', color: '#888' }}>VIEW_DOCUMENTS_HUB</span>
                        </div>
                    </div> */}
                </div>

                <div className="graph-container glass-morph" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h5 className="chart-title" style={{ textAlign: 'center', width: '100%' }}>
                        {filters.department === 'All' ? 'GLOBAL_DISTRIBUTION' : `${filters.department.toUpperCase()}_STATUS`}
                    </h5>
                    <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
                        <ResponsiveContainer width="100%" height={220}>
                            <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
                                <XAxis dataKey="name" tick={{ fill: '#888', fontSize: 10 }} axisLine={false} tickLine={false} />
                                <YAxis tick={{ fill: '#666', fontSize: 10 }} axisLine={false} tickLine={false} />
                                <Tooltip cursor={{ fill: 'transparent' }} contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #333', fontSize: '12px' }} />
                                <Legend iconType="circle" wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }} />
                                <Bar dataKey="Approved" stackId="a" fill="#10b981" barSize={filters.department === 'All' ? 20 : 60} />
                                <Bar dataKey="Pending" stackId="a" fill="#f59e0b" barSize={filters.department === 'All' ? 20 : 60} radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>


            </div>

            <div className="filter-toolbar glass-morph">

                <div className="leavefilter">
                    <label>MONTH</label>
                    <select name="month" value={filters.month} onChange={handleFilterChange}>
                        <option value="All">ALL MONTHS</option>
                        {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"].map(m => (
                            <option key={m} value={m}>{new Date(0, m - 1).toLocaleString('default', { month: 'long' }).toUpperCase()}</option>
                        ))}
                    </select>
                </div>
                <div className="leavefilter">
                    <label>YEAR</label>
                    <select name="year" value={filters.year} onChange={handleFilterChange}>
                        <option value="All">ALL YEARS</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                    </select>
                </div>

                <div className="leavefilter">
                    <label>DEPARTMENT</label>
                    <select name="department" value={filters.department} onChange={handleFilterChange}>
                        <option value="All">ALL DEPARTMENTS</option>
                        {teams.map(team => (
                            <option key={team} value={team}>{team.toUpperCase()}</option>
                        ))}
                    </select>
                </div>

                <div className="leavefilter search-group">
                    <label>EMPLOYEE_SEARCH</label>
                    <input type="text" placeholder="ID OR NAME..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="leavefilter reset-group">
                    <label>SYSTEM_CONTROL</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                            className="reset-action-btn"
                            onClick={() => {
                                setFilters({
                                    department: 'All',
                                    month: currentMonth, // Returns to original current month
                                    year: currentYear,   // Returns to original current year
                                });
                                setSearchTerm('');
                                setCurrentPage(1);
                            }}
                        >
                            <span className="reset-icon"></span>
                            RESET_FILTER
                        </button>

                        <button
                            type="button"
                            className="reset-action-btn"
                            style={{ backgroundColor: '#10b981', color: '#fff', borderColor: '#10b981', cursor: 'pointer' }}
                            onClick={() => {
                                setReportDates({ start: '', end: '' });
                                setReportData([]);
                                setHasReportGenerated(false);
                                setShowReportModal(true);
                            }}
                        >
                            📊 WFH_REPORT
                        </button>
                    </div>
                </div>
            </div>

            <div className="module-glass-card table-wrapper">
                <div style={{ display: 'flex', alignItems: 'center', padding: '15px' }}>
                    <h3 className="table-title cyan-text" style={{ margin: 0 }}>APPLICATION_LOG</h3>
                    {pendingCount > 0 && (
                        <div className="notif-badge-main">{pendingCount}</div>
                    )}
                </div>


                <table className="cyber-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>


                            <th style={{ width: '220px', textAlign: 'left', padding: '12px' }}>EMPLOYEE</th>

                            <th style={{ width: '160px', textAlign: 'left', padding: '12px' }}>DEPT</th>

                            <th style={{ width: '140px', textAlign: 'center', padding: '12px' }}>FROM</th>

                            <th style={{ width: '140px', textAlign: 'center', padding: '12px' }}>TO</th>

                            <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>UNIT</th>

                            <th style={{ width: '140px', textAlign: 'center', padding: '12px' }}>STATUS</th>

                            <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>REVIEW</th>

                            <th style={{ width: '90px', textAlign: 'center', padding: '12px' }}>ACTION</th>
                        </tr>
                    </thead>

                    <tbody>
                        {currentEntries.map((l, i) => (

                            <tr key={i} className="row-hover">

                                <td className="emp-name-cell"
                                    style={{
                                        padding: '14px 12px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}>
                                    {l.employee_name}
                                </td>

                                <td style={{ padding: '14px 12px' }}>
                                    {l.department}
                                </td>

                                <td style={{ textAlign: 'center' }}>
                                    {l.start}
                                </td>

                                <td style={{ textAlign: 'center' }}>
                                    {l.end}
                                </td>

                                <td style={{ fontWeight: 'bold', color: '#00fff2', textAlign: 'center' }}>
                                    {parseFloat(l.total_days)}
                                </td>

                                <td style={{ textAlign: 'center', transform: 'translateX(45px)' }}>
                                    <span className={`status-pill ${getStatusLabel(l.status).toLowerCase()}`} style={{ fontSize: '11px' }}>
                                        {getStatusLabel(l.status)}
                                    </span>
                                </td>

                                <td style={{ textAlign: 'center', transform: 'translateX(35px)' }}>
                                    <button
                                        className="info-btn-circle"
                                        style={{ marginTop: '-4px' }}
                                        onClick={() => { setSelectedLeave(l); setShowDetailModal(true); }}
                                    >
                                        <span className="info-icon">i</span>
                                    </button>
                                </td>

                                <td style={{ textAlign: 'center' }}>
                                    {(l.status !== '0' && l.status !== null) && (
                                        <button
                                            className="btn-delete-simple"
                                            onClick={() => handleDeleteLeave(l.id)}
                                            style={{
                                                background: 'none',
                                                border: '6px',
                                                padding: '0',
                                                cursor: 'pointer',
                                                fontSize: '22px',
                                                opacity: '0.8',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: '-4px'
                                            }}
                                        >
                                            🗑️
                                        </button>
                                    )}
                                </td>

                            </tr>

                        ))}
                    </tbody>
                </table>





                <div className="pagination-footer">
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="page-btn">PREV</button>
                    <span className="page-info">PAGE {currentPage} OF {totalPages || 1}</span>
                    <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(p => p + 1)} className="page-btn">NEXT</button>
                </div>
            </div>





            <div className="module-glass-card table-wrapper" style={{ marginTop: '40px', width: '100%', overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 10px 20px' }}>
                    {/* <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>EMPLOYEE_LEAVE_SUMMARY</h3> */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '20px 20px 10px 20px',
                        gap: '15px'
                    }}>
                        <h3 className="table-title cyan-text" style={{ margin: 0, fontWeight: '800' }}>
                            EMPLOYEE_WFH_USAGE
                        </h3>

                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>

                            {/* ✅ New Department Filter for Summary Only */}
                            <select
                                className="filter-select"
                                value={summaryDepartment}
                                onChange={(e) => setSummaryDepartment(e.target.value)}
                                style={{ fontSize: '12px' }}
                            >
                                <option value="All">ALL DEPARTMENTS</option>
                                {teams.map(team => (
                                    <option key={team} value={team}>{team.toUpperCase()}</option>
                                ))}
                            </select>


                        </div>
                    </div>
                    <input type="text" placeholder="Search Employee..." className="filter-select" value={summarySearch} onChange={(e) => setSummarySearch(e.target.value)} style={{ width: '220px', fontSize: '12px' }} />
                </div>
                <div className="table-header-row" style={{ display: 'flex', padding: '12px 20px' }}>
                    <div className="header-label" style={{ flex: '3' }}>EMPLOYEE</div>
                    <div className="header-label" style={{ flex: '2' }}>DEPARTMENT</div>
                    <div className="header-label" style={{ flex: '1.5', textAlign: 'center' }}>
                        TOTAL_WFH_USED
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    {wfhUsage.map((emp, idx) => (

                        <div key={idx} className="row-hover"
                            style={{ display: 'flex', padding: '14px 20px', alignItems: 'center' }}>

                            <div style={{
                                flex: '3',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {emp.name}
                            </div>

                            <div style={{
                                flex: '2',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {emp.dept}
                            </div>

                            <div style={{
                                flex: '1.5',
                                textAlign: 'center',
                                fontWeight: '800',
                                fontSize: '15px',
                                color: '#00fff2'
                            }}>
                                {emp.total}/12
                            </div>

                        </div>

                    ))}

                    {wfhUsage.length === 0 &&
                        <div style={{ textAlign: 'center', padding: '40px', color: '#888', letterSpacing: '2px' }}>
                            DATA_NOT_FOUND_FOR_PERIOD
                        </div>}

                </div>
            </div>

            {showReportModal && createPortal(
                <div className="modal-overlay" onClick={() => setShowReportModal(false)} style={{ zIndex: 3000, backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="detail-modal animate-slide-up"
                        onClick={e => e.stopPropagation()}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '90vh',
                            width: '90%',
                            maxWidth: '900px',
                            backgroundColor: '#ffffff',
                            color: '#1e293b',
                            borderRadius: '16px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                            border: '1px solid #e2e8f0',
                            overflow: 'hidden'
                        }}
                    >
                        <div className="modal-header" style={{ flexShrink: 0, borderBottom: '1px solid #e2e8f0', padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff' }}>
                            <h3 style={{ color: '#0f172a', margin: 0, fontWeight: '700', fontSize: '18px' }}>📊 WFH DURATION REPORT GENERATOR</h3>
                            <button onClick={() => setShowReportModal(false)} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#64748b', cursor: 'pointer', lineHeight: '1' }}>×</button>
                        </div>

                        <div className="modal-body" style={{ padding: '24px', overflowY: 'auto', flex: 1, backgroundColor: '#ffffff' }}>
                            <form onSubmit={handleGenerateReport} style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '16px', marginBottom: '24px', background: '#f8fafc', border: '1px solid #e2e8f0', padding: '16px 20px', borderRadius: '12px', width: '100%', boxSizing: 'border-box' }}>
                                <div style={{ flex: '1', minWidth: '180px' }}>
                                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: '#475569', fontWeight: '700', letterSpacing: '0.5px' }}>START DATE</label>
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <input
                                            ref={reportStartDateRef}
                                            type="date"
                                            required
                                            style={{ width: '100%', height: '40px', padding: '0 36px 0 12px', background: '#ffffff', color: '#0f172a', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }}
                                            value={reportDates.start}
                                            onChange={e => setReportDates(prev => ({ ...prev, start: e.target.value }))}
                                        />
                                        <button
                                            type="button"
                                            style={{ position: 'absolute', right: '10px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', lineHeight: '1' }}
                                            onClick={() => reportStartDateRef.current?.showPicker()}
                                        >
                                            📅
                                        </button>
                                    </div>
                                </div>

                                <div style={{ flex: '1', minWidth: '180px' }}>
                                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', color: '#475569', fontWeight: '700', letterSpacing: '0.5px' }}>END DATE</label>
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <input
                                            ref={reportEndDateRef}
                                            type="date"
                                            required
                                            style={{ width: '100%', height: '40px', padding: '0 36px 0 12px', background: '#ffffff', color: '#0f172a', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }}
                                            value={reportDates.end}
                                            onChange={e => setReportDates(prev => ({ ...prev, end: e.target.value }))}
                                        />
                                        <button
                                            type="button"
                                            style={{ position: 'absolute', right: '10px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', lineHeight: '1' }}
                                            onClick={() => reportEndDateRef.current?.showPicker()}
                                        >
                                            📅
                                        </button>
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    style={{ height: '40px', padding: '0 24px', cursor: 'pointer', backgroundColor: '#10b981', color: '#ffffff', border: 'none', borderRadius: '8px', fontWeight: '700', fontSize: '13px', whiteSpace: 'nowrap', flexShrink: 0 }}
                                >
                                    GENERATE REPORT
                                </button>
                            </form>

                            {hasReportGenerated && (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
                                        <div style={{ color: '#0f172a', fontWeight: '700', fontSize: '15px' }}>
                                            Found <span style={{ color: '#2563eb' }}>{reportData.length}</span> records (<span style={{ color: '#2563eb' }}>{reportData.reduce((sum, r) => sum + parseFloat(r.total_days || 0), 0)}</span> total days)
                                        </div>
                                        {reportData.length > 0 && (
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <button
                                                    type="button"
                                                    onClick={handleExportCSV}
                                                    style={{ background: '#0284c7', color: '#ffffff', border: 'none', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}
                                                >
                                                    📥 EXPORT CSV
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleExportPDF}
                                                    style={{ background: '#0284c7', color: '#ffffff', border: 'none', padding: '10px 18px', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}
                                                >
                                                    📄 EXPORT PDF
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ overflowX: 'auto', border: '1px solid #e2e8f0', borderRadius: '12px' }}>
                                        <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse', background: '#ffffff' }}>
                                            <thead>
                                                <tr style={{ background: '#f1f5f9', borderBottom: '2px solid #e2e8f0' }}>
                                                    <th style={{ padding: '12px 14px', textAlign: 'left', color: '#334155', fontWeight: '700' }}>EMP ID</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'left', color: '#334155', fontWeight: '700' }}>EMPLOYEE</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'left', color: '#334155', fontWeight: '700' }}>DEPT</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'center', color: '#334155', fontWeight: '700' }}>FROM</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'center', color: '#334155', fontWeight: '700' }}>TO</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'center', color: '#334155', fontWeight: '700' }}>DAYS</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'center', color: '#334155', fontWeight: '700' }}>STATUS</th>
                                                    <th style={{ padding: '12px 14px', textAlign: 'left', color: '#334155', fontWeight: '700' }}>REASON</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reportData.map((r, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                                        <td style={{ padding: '12px 14px', color: '#475569' }}>{r.empid}</td>
                                                        <td style={{ padding: '12px 14px', color: '#0f172a', fontWeight: '600' }}>{r.employee_name}</td>
                                                        <td style={{ padding: '12px 14px', color: '#475569' }}>{r.department}</td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'center', color: '#475569' }}>{r.start}</td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'center', color: '#475569' }}>{r.end}</td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'center', fontWeight: '800', color: '#2563eb' }}>{parseFloat(r.total_days)}</td>
                                                        <td style={{ padding: '12px 14px', textAlign: 'center' }}>
                                                            <span className={`status-pill ${getStatusLabel(r.status).toLowerCase()}`}>
                                                                {getStatusLabel(r.status)}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '12px 14px', color: '#475569', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.reason}>
                                                            {r.reason}
                                                        </td>
                                                    </tr>
                                                ))}

                                                {reportData.length === 0 && (
                                                    <tr>
                                                        <td colSpan="8" style={{ textAlign: 'center', padding: '36px', color: '#64748b' }}>
                                                            No WFH records found for the selected duration.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="modal-footer" style={{ flexShrink: 0, borderTop: '1px solid #e2e8f0', padding: '16px 24px', display: 'flex', justifyContent: 'flex-end', backgroundColor: '#f8fafc' }}>
                            <button onClick={() => setShowReportModal(false)} style={{ padding: '8px 20px', background: '#ffffff', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}>CLOSE</button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default WFHManagement;

